import { PatientRepository } from "@/domain/repository/patient-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class ResendPatientAccountSetupSmsUsecase {
  constructor(private readonly patientRepo: PatientRepository) {}

  async execute(patientUuid: string): Promise<SATResult<void, SATError>> {
    if (!patientUuid) {
      throw new Error("[ResendPatientAccountSetupSmsUsecase] patientUuid is required");
    }

    return this.patientRepo.resendAccountSetupSms(patientUuid);
  }
}
